import Vue from 'vue';
import Router from 'vue-router';
import store from '@/common/store';
import {loadServiceCss} from '@/iamteacherpc/utils/service.js';
import SimpleErrorMessage from '@common/views/SimpleErrorMessage.vue';
import {PAGE_TYPE} from '@/common/consts/service.js';
import {removeToast} from '@/common/utils/simpleToast.js';
import i18n, {loadLangPromise} from '@common/i18n.js';
import {LANGUAGE_RESOURCE} from '@/common/i18n.js';

Vue.use(Router);

function responseProps(route) {
    return {
        serviceId: route.query.serviceId,
        isPreview: route.query.isPreview === 'true' || false,
    };
}

function loadEditorCss(serviceId) {
    // 서비스에 맞는 CSS를 로드한다.
    loadServiceCss(serviceId, PAGE_TYPE.EDITOR);
}

function loadResponseCss(serviceId) {
    // 서비스에 맞는 CSS를 로드한다.
    loadServiceCss(serviceId, PAGE_TYPE.RESPONSE);
}

function loadCoronaResponseCss(serviceId) {
    //서비스에 맞는 CSS를 로드한다.
    loadServiceCss(serviceId, PAGE_TYPE.CORONA_RESPONSE);
}

const router = new Router({
    mode: 'history',
    base: '',
    routes: [
        {
            path: '/survey/editor',
            name: 'surveyEditor',
            component: () => import(/* webpackChunkName: "page-surveyEditor" */ '@/iamteacherpc/views/survey/Editor.vue'),
            props(route) {
                return {
                    showQuestion: route.query.showQuestion ? route.query.showQuestion === 'true' : true
                }
            }
        },
        {
            path: '/survey/response',
            meta: {
                pageTitle: '설문투표콘텐츠상세',
            },
            component: () => import(/* webpackChunkName: "page-surveyResponse" */ '@/iamteacherpc/views/survey/Response.vue'),
            children: [
                {
                    path: '',
                    name: 'surveyResponse',
                    component: () => import(/* webpackChunkName: "page-surveyResponse" */ '@/iamteacherpc/views/survey/ResponseDefault.vue'),
                    props: responseProps
                },
                {
                    path: 'previewImage',
                    name: 'surveyResponseImage',
                    component: () => import(/* webpackChunkName: "page-preview" */ '@/iamteacherpc/views/common/preview/PreviewImage.vue'),
                    props(route) {
                        const survey = store.state.surveyResponse.survey;

                        return {
                            attachments: survey.attachments,
                            order: route.query.order && parseInt(route.query.order) || 0
                        }
                    }
                },
                {
                    path: 'previewFile',
                    name: 'surveyResponseFile',
                    component: () => import(/* webpackChunkName: "page-preview" */ '@/iamteacherpc/views/common/preview/PreviewFile.vue'),
                    props(route) {
                        const survey = store.state.surveyResponse.survey;
                        const order = route.query.order && parseInt(route.query.order) || 0;

                        return {
                            type: 'survey',
                            document: survey.documents[order],
                        }
                    },
                    children: [
                        {
                            path: 'previewImage',
                            name: 'surveyResponseFileImage',
                            component: () => import(/* webpackChunkName: "page-preview" */ '@/iamteacherpc/views/common/preview/PreviewImage.vue'),
                            props(route) {
                                const survey = store.state.surveyResponse.survey;
                                const order = route.query.order && parseInt(route.query.order) || 0;
                                const document = survey.documents[order];

                                return {
                                    attachments: document.attachments,
                                    order: route.query.imageOrder && parseInt(route.query.imageOrder) || 0
                                }
                            }
                        },
                    ]
                },
            ],
        },
        {
            path: '/survey/response/alreadyAnswer',
            name: 'surveyAlreadyAnswer',
            meta: {
                pageTitle: '설문투표콘텐츠상세',
            },
            component: () => import(/* webpackChunkName: "page-surveyResponse" */ '@/iamteacherpc/views/survey/ResponseAlreadyAnswer.vue'),
            props: responseProps
        },
        {
            path: '/survey/response/expired',
            name: 'surveyExpired',
            meta: {
                pageTitle: '설문투표콘텐츠상세',
            },
            component: () => import(/* webpackChunkName: "page-surveyResponse" */ '@/iamteacherpc/views/survey/ResponseExpired.vue'),
            props: responseProps
        },
        {
            path: '/survey/response/complete',
            name: 'surveyComplete',
            meta: {
                pageTitle: '설문투표콘텐츠상세',
            },
            component: () => import(/* webpackChunkName: "page-surveyResponse" */ '@/iamteacherpc/views/survey/ResponseComplete.vue'),
            props(route) {
                return {
                    ...responseProps(route),
                    preQuestionAnswerState: store.state.surveyResponse?.survey.preQuestionAnswerState,
                };
            },
        },
        {
            path: '/enrolment/editor',
            name: 'enrolmentEditor',
            component: () => import(/* webpackChunkName: "page-enrolmentEditor" */ '@/iamteacherpc/views/enrolment/Editor.vue'),
        },
        {
            path: '/enrolment/response',
            meta: {
                pageTitle: '수강신청콘텐츠상세',
            },
            component: () => import(/* webpackChunkName: "page-enrolmentResponse" */ '@/iamteacherpc/views/enrolment/Response.vue'),
            props: responseProps,

            children: [
                {
                    path: '',
                    name: 'enrolmentResponse',
                    component: () => import(/* webpackChunkName: "page-enrolmentResponse" */ '@/iamteacherpc/views/enrolment/ResponseDefault.vue'),
                    props: responseProps,
                },
                {
                    path: 'previewImage',
                    name: 'enrolmentResponseImage',
                    component: () => import(/* webpackChunkName: "page-preview" */ '@/iamteacherpc/views/common/preview/PreviewImage.vue'),
                    props(route) {
                        const survey = store.state.enrolmentResponse.survey.contents;

                        return {
                            attachments: survey.attachments,
                            order: route.query.order && parseInt(route.query.order) || 0
                        }
                    }
                },
                {
                    path: 'previewFile',
                    name: 'enrolmentResponseFile',
                    component: () => import(/* webpackChunkName: "page-preview" */ '@/iamteacherpc/views/common/preview/PreviewFile.vue'),
                    props(route) {
                        const survey = store.state.enrolmentResponse.survey.contents;
                        const order = route.query.order && parseInt(route.query.order) || 0;

                        return {
                            type: 'enrolment',
                            document: survey.documents[order],
                        }
                    },
                    children: [
                        {
                            path: 'previewImage',
                            name: 'enrolmentResponseFileImage',
                            component: () => import(/* webpackChunkName: "page-preview" */ '@/iamteacherpc/views/common/preview/PreviewImage.vue'),
                            props(route) {
                                const survey = store.state.enrolmentResponse.survey.contents;
                                const order = route.query.order && parseInt(route.query.order) || 0;
                                const document = survey.documents[order];

                                return {
                                    attachments: document.attachments,
                                    order: route.query.imageOrder && parseInt(route.query.imageOrder) || 0
                                }
                            }
                        },
                    ]
                },
            ]
        },
        {
            path: '/enrolment/response/preview-image/:orderNo/:mode',
            name: 'enrolmentResponsePreviewImage',
            component: () => import(/* webpackChunkName: "page-enrolmentResponse" */ '@/iamteacherpc/views/common/preview/PreviewImage.vue'),
        },
        {
            path: '/enrolment/response/preview-file',
            name: 'enrolmentResponsePreviewFile',
            component: () => import(/* webpackChunkName: "page-enrolmentResponse" */ '@/iamteacherpc/views/common/preview/PreviewFile.vue'),
        },

        //코로나19 대응 자가진단 응답페이지
        {
            path: '/corona/response',
            name: 'coronaResponse',
            component: () => import(/* webpackChunkName: "page-coronaResponse" */ '@/iamteacherpc/views/corona/CoronaResponse.vue'),
        },
        {
            path: '*',
            name: 'notFound',
            meta: {title: i18n.t('common_pageNotFound')},
            component: SimpleErrorMessage,
            props: {
                payload: {message: 'common_pageNotFoundDesc'},
            },
        },
    ]
});

// 문자 웹링크 대비
router.beforeEach((to, from, next) => {
    const keyArr = Object.keys(to.query);
    switch (true) {
        // 교직원
        case keyArr.includes('T'):
            window.location.href = `/iamteacherapp${window.location.pathname}${window.location.search}`;
            return;
        // 학부모, 학생
        case keyArr.includes('P'):
        case keyArr.includes('S'):
        default:
            next();
            return;
    }
})

router.beforeEach(async (to, from, next) => {
    await loadLangPromise;
    next();
});

router.beforeEach((to, from, next) => {
    if (/\/corona\/response/.test(to.path)) {
        loadCoronaResponseCss(to.query.serviceId);
    } else if (/\/response/.test(to.path)) {
        loadResponseCss(to.query.serviceId);
    } else if (/\/editor/.test(to.path)) {
        loadEditorCss(to.query.serviceId);
    }

    removeToast();

    next();
});

export default router;
